"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateGiveawaySchedulerConfig200ResponseToJSON = exports.CreateGiveawaySchedulerConfig200ResponseFromJSONTyped = exports.CreateGiveawaySchedulerConfig200ResponseFromJSON = exports.instanceOfCreateGiveawaySchedulerConfig200Response = void 0;
var GiveawaySchedulerConfig_1 = require("./GiveawaySchedulerConfig");
/**
 * Check if a given object implements the CreateGiveawaySchedulerConfig200Response interface.
 */
function instanceOfCreateGiveawaySchedulerConfig200Response(value) {
    var isInstance = true;
    isInstance = isInstance && "data" in value;
    return isInstance;
}
exports.instanceOfCreateGiveawaySchedulerConfig200Response = instanceOfCreateGiveawaySchedulerConfig200Response;
function CreateGiveawaySchedulerConfig200ResponseFromJSON(json) {
    return CreateGiveawaySchedulerConfig200ResponseFromJSONTyped(json, false);
}
exports.CreateGiveawaySchedulerConfig200ResponseFromJSON = CreateGiveawaySchedulerConfig200ResponseFromJSON;
function CreateGiveawaySchedulerConfig200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': (0, GiveawaySchedulerConfig_1.GiveawaySchedulerConfigFromJSON)(json['data']),
    };
}
exports.CreateGiveawaySchedulerConfig200ResponseFromJSONTyped = CreateGiveawaySchedulerConfig200ResponseFromJSONTyped;
function CreateGiveawaySchedulerConfig200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, GiveawaySchedulerConfig_1.GiveawaySchedulerConfigToJSON)(value.data),
    };
}
exports.CreateGiveawaySchedulerConfig200ResponseToJSON = CreateGiveawaySchedulerConfig200ResponseToJSON;
